module.exports = __webpack_public_path__ + "static/media/Dragon Costume.eec749fe.jpg";